export default __webpack_public_path__ + "static/media/userFour.79fe37be.svg";